const messages = {
  featuredArticlesTitle: 'featuredArticles.title',
  pressReleasesTabLabel: 'tabs.label.pressReleases',
  inTheMediaTabLabel: 'tabs.label.inTheMedia',
};

export default messages;
